import React from 'react'

import StorfoxAreaStatusField, { OPTIONS as BASE_OPTIONS } from '~/components/Fields/AreaStatusField'

const OPTIONS = [{ value: '', name: 'All' }, ...BASE_OPTIONS]

function AreaStatusField (props) {
  return (
    <StorfoxAreaStatusField
      name="status"
      label="Status"
      options={OPTIONS}
      {...props}
    />
  )
}

export default AreaStatusField
